<ng-container>
    <div class="ppl-container-body">
        <div class="ppl-container-head ledger-head">
            <div class="ledger-head__titles">
                <h1 class="ledger-title">Consumer Ledger</h1>
            </div>

            <div class="ledger-search">
                <!-- <label class="ledger-search__label" for="pplIdSearch">PPL ID</label> -->
                <input
                    id="pplIdSearch"
                    nz-input
                    type="text"
                    class="ledger-search__input"
                    placeholder="Search PPL ID"
                    [(ngModel)]="searchPplId"
                    (keydown.enter)="onSearch()" />
                <button
                    type="button"
                    class="ledger-search__btn"
                    aria-label="Search by PPL ID"
                    (click)="onSearch()">
                    <i class="fa fa-search" aria-hidden="true"></i>
                </button>
            </div>
        </div>

        <div class="ppl-container">
            <div class="ppl-content-container">
                @if (claims.length > 0) {
                <section class="participant-card">
                    <div class="participant-fields">
                        <!-- <div class="participant-field">
                            <span class="participant-field__label">Participant ID</span>
                            <span class="participant-field__value">{{ participant.participantId }}</span>
                        </div> -->
                        <div class="participant-field">
                            <span class="participant-field__label">PPL ID</span>
                            <span class="participant-field__value participant-field__value--mono">{{ participant.participantPplId }}</span>
                        </div>
                        <div class="participant-field">
                            <span class="participant-field__label">Full Name</span>
                            <span class="participant-field__value">{{ participant.fullName }}</span>
                        </div>
                        <div class="participant-field">
                            <span class="participant-field__label">Date of Birth</span>
                            <span class="participant-field__value">{{ participant.dateOfBirth }}</span>
                        </div>
                        <div class="participant-field">
                            <span class="participant-field__label">Gender</span>
                            <span class="participant-field__value">{{ participant.gender }}</span>
                        </div>
                    </div>

                    <div class="ledger-filters">
                        <div class="ledger-filters__field">
                            <label for="searchPplIcn">PPL ICN</label>
                            <input
                                id="searchPplIcn"
                                nz-input
                                type="text"
                                placeholder="Search PPL ICN"
                                [(ngModel)]="searchPplIcn"
                                (keydown.enter)="onFiltersChange()" />
                        </div>
                        <div class="ledger-filters__field">
                            <label for="filterMco">MCO</label>
                            <ppl-dropdown-select id="filterMco" [(ngModel)]="filterMco"
                                [options]="mcoOptions" placeholder="Select MCO…"
                                (selectionChange)="onFiltersChange()">
                            </ppl-dropdown-select>
                        </div>
                        <div class="ledger-filters__field">
                            <label for="filterStartDate">Start Date</label>
                            <nz-date-picker
                                id="filterStartDate"
                                [(ngModel)]="filterStartDate"
                                [nzFormat]="'MM/dd/yyyy'"
                                [nzPlaceHolder]="'Start Date'">
                            </nz-date-picker>
                        </div>
                        <div class="ledger-filters__field">
                            <label for="filterEndDate">End Date</label>
                            <nz-date-picker
                                id="filterEndDate"
                                [(ngModel)]="filterEndDate"
                                [nzFormat]="'MM/dd/yyyy'"
                                [nzPlaceHolder]="'End Date (defaults to today)'">
                            </nz-date-picker>
                        </div>
                        <div class="ledger-filters__field">
                            <button
                                type="button"
                                class="ledger-filters__search-btn"
                                aria-label="Search"
                                (click)="onFiltersChange()">
                                <i class="fa fa-search" aria-hidden="true"></i>
                            </button>
                        </div>
                    </div>
                </section>

                <div class="w-100">
                    <ppl-list-table
                        [data]="claims"
                        [cols]="cols"
                        [from]="'billing'"
                        [disableSort]="true"
                        [disableSearch]="true"
                        [showCustomSearch]="false"
                        [disableSelection]="true"
                        [gridTitle]="false"
                        [enableActions]="false"
                        [showExpandIcon]="true"
                        [showLineItem]="true"
                        [lineItemCols]="lineItemCols"
                        (rowDetailEvent)="rowClicked($event)"
                        (rowDetailEventTs)="onClaimClick($event)"
                        [pagination]="true"
                        [rowsToDisplay]="20"
                        [loadPage]="false"
                        [tableScrollable]="true">
                    </ppl-list-table>
                </div>
                } @else {
                <div class="alert alert-warning"><strong>No Records Found. </strong>Please change the filters to
                    find the records</div>
                }
            </div>
        </div>
    </div>
</ng-container>
